import { useEffect, useState } from 'react'

import { Feedback } from '@percent/lemonade'

import { DraftSaveStatus } from '../hooks/useTaskDraftAutosave'
import styles from './TaskDraftSaveStatus.module.scss'

const RELATIVE_TIME_REFRESH_MS = 30_000

export type TaskDraftSaveStatusProps = {
  status: DraftSaveStatus
  lastSavedAt: number | null
  savingLabel: string
  errorLabel: string
  renderSavedLabel: (lastSavedAt: number) => string
}

export function TaskDraftSaveStatus({
  status,
  lastSavedAt,
  savingLabel,
  errorLabel,
  renderSavedLabel,
}: Readonly<TaskDraftSaveStatusProps>) {
  const [, setTick] = useState(0)

  useEffect(() => {
    if (status !== 'saved' || !lastSavedAt) {
      return undefined
    }

    const interval = setInterval(
      () => setTick((tick) => tick + 1),
      RELATIVE_TIME_REFRESH_MS
    )

    return () => clearInterval(interval)
  }, [status, lastSavedAt])

  if (status === 'saving') {
    return (
      <span className={styles.savingIcon}>
        <Feedback variant="default" icon="recurring">
          {savingLabel}
        </Feedback>
      </span>
    )
  }

  if (status === 'error') {
    return (
      <Feedback variant="critical" icon="warning">
        {errorLabel}
      </Feedback>
    )
  }

  if (status === 'saved' && lastSavedAt) {
    return (
      <Feedback variant="positive" icon="check">
        {renderSavedLabel(lastSavedAt)}
      </Feedback>
    )
  }

  return null
}
